import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

/**
 * Redirects any not-found route back to the organizations page.
 */
export function NotFound() {
    const navigate = useNavigate();

    useEffect(() => {
        void navigate({ to: '/organizations', replace: true });
    }, [navigate]);

    return null;
}
